export const ProgressRow = ({ label, done, total, mailbox, seqIndex, seqTotal }) => (
  <div data-testid="progress-row">
    <div className="flex justify-between text-[11px] text-muted-foreground mb-1">
      <span className="truncate">
        {label}
        {mailbox && <span className="text-[#007BFF] font-medium ml-1" data-testid="progress-mailbox">· {mailbox}</span>}
        {seqTotal > 1 && <span className="text-muted-foreground ml-1" data-testid="progress-seq">(casella {seqIndex}/{seqTotal})</span>}
      </span>
      <span className="shrink-0 ml-2">{done}/{total || "…"}</span>
    </div>
    <div className="h-1.5 bg-white rounded-full overflow-hidden border border-border">
      <div className="h-full bg-[#007BFF] transition-all duration-500" style={{ width: total ? `${Math.min(100, (done / total) * 100)}%` : "20%" }} />
    </div>
  </div>
);
